import { createLink } from "@tanstack/react-router"
import { Card, cn } from "@motleyhand/design"
import type { ComponentProps } from "react"

const CardLink = createLink(
  ({ className, ...props }: Omit<ComponentProps<typeof Card>, "as">) => (
    <Card {...props} className={cn("cursor-pointer", className)} as="a" />
  ),
)

export default CardLink
